import React from 'react';
// import { Button } from "@material-ui/core";
// import { makeStyles } from "@material-ui/core/styles";
import { ComonIcons } from '../../contents/commonIcons';

export const FormFooter = (props) => {
  const { step } = props;
  switch (step) {
    case 1:
      return (
        <>
          <div className='step-block'>
            <ul className='step-wrapper'>
              <li className='step active '>
                <div className='step-inner-block'>
                  <div class='block-1'></div>
                  <div className='block-2'>
                    <h4 className='mb-0'>Step One : Personal Information</h4>
                  </div>
                </div>
              </li>
              <li className='step '>
                <div className='step-inner-block'>
                  <div class='block-1'></div>
                  <div className='block-2'>
                    <h4 className='mb-0'>Step Two: Further Info</h4>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </>
      );
    case 2:
      return (
        <>
          <div className='step-block'>
            <ul className='step-wrapper'>
              <li className='step active completed'>
                <div className='step-inner-block'>
                  <div class='block-1'>{ComonIcons.done}</div>
                  <div className='block-2'>
                    <h4 className='mb-0'>Step One : Personal Information</h4>
                  </div>
                </div>
              </li>
              <li className='step active'>
                <div className='step-inner-block'>
                  <div class='block-1'></div>
                  <div className='block-2'>
                    <h4 className='mb-0'>Step Two: Further Info</h4>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </>
      );
    default:
      return <></>;
  }
};
